import { forwardRef, ElementType, ButtonHTMLAttributes } from 'react';

interface INavButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  Icon: ElementType;
}

const NavButton = forwardRef<HTMLButtonElement, INavButtonProps>((props, ref) => {
  const { children, Icon, className = '', type = 'button', ...rest } = props;

  // On mobile the bar is 56px (44px in landscape) and the icon has to stay a
  // 44x44 touch target, so the label is dropped -- which is also how the design's
  // own portrait/landscape sketches show the tool row (`[ref] [fx]`).
  const classNames = `inline-flex flex-col justify-center items-center gap-0.5 shrink-0 h-16 p-2 pb-0 rounded-xs
    bg-neutral2 hover:bg-neutral2-hover
    text-callout font-medium text-neutral2-text hover:text-neutral2-hover-text
    m:h-11 m:w-11 m:p-0 m:gap-0 m:active:bg-neutral2-hover
    ${className}`;

  return (
    <button type={type} ref={ref} className={classNames} {...rest}>
      <Icon width={20} height={20} className="text-neutral-icon" />
      <span className="m:hidden">{children}</span>
    </button>
  );
});

export default NavButton;
